import React, { Component } from "react";
import TopBar from "../../components/TopBar";
import BottomBar from "../../components/BottomBar";
import "./Dialogduk.css";
import "../styles.css";

const text = `Her kan du laste ned en utskriftsvennlig gratisversjon av innholdet i dialogdukene.
Versjonene inneholder de samme spørsmålene og oppgavene, men formatet er tilpasset en
vanlig skriver (dialogdukene er originalt 100 x 70 cm). Du kan bruke den samme
veilederguiden, men må dele ut oppgavene til diskusjon fortløpende under foreldremøtet.`;

/* Images */
const img1 = require("./static/veilederguide2.png");
const img2 = require("./static/veilederguide1.png");
const img3 = require("./static/checklist.png");
const img4 = require("./static/invitation.png");
const images = [img1, img2, img3, img4];
const img5 = require("./static/dialogduk2.png");
const img6 = require("./static/dialogduk1.png");
const images2 = [img5, img6];
/* End of Images*/

/* ImageTitles */
const titles = [
  "Veilederguide\n blå dialogduk",
  "Veilederguide\n rød dialogduk",
  "Sjekkliste\n før foreldremøte",
  `Invitasjon\n til foreldremøte`,
];
const titles2 = ["A4/A3\n blå dialogduk", "A4/A3\n rød dialogduk"];
/* End of ImageTitles */

/* End of ImageText */

/* Link-texts */
const links = [
  "Last ned PDF 3.4 MB",
  "Last ned PDF 1.2 MB",
  "Last ned PDF 0.4 MB",
  "Last ned Word-fil 49 KB",
];
const links2 = ["Last ned PDF 3.8 MB", "Last ned PDF 1.7 MB"];
/* End of Link-texts */

const href1 = `veilederguide2`;
const href2 = `veilederguide`;
const href3 = `sjekkliste`;
const href4 = `invitation`;
const hrefArray = [href1, href2, href3, href4];
const href5 = "Digital dømmekraft dialogduk blå(A4)";
const href6 = "Digital dømmekraft dialogduk rød(A4)";
const hrefArray2 = [href5, href6];

class Kursmateriell extends Component {
  openLinks = () => {
    const { history } = this.props;
    history.push({
      pathname: "/dialogduk/linker",
      search: history.location.search,
    });
  };

  render() {
    return (
      <div className="OuterContainer">
        <div style={{ display: "block" }}>
          <TopBar activePage={"Dialogduk"} />
        </div>
        <div className="Container-cinderella">
          <div className="Kursmateriell-container">
            <div className="Column ">
              <div className="dialogduk-block-1">
                <div className="Row Center-content">
                  <div className="Kursmateriell-main-title">
                    Støttemateriell til bruk av dialogdukene
                  </div>
                </div>
                <div className="Kursmateriell-empty-space-main-title-bottom" />
                <div className="Row Kursmateriell-Center-content">
                  {images.map((img, index) => (
                    <div
                      className="Row"
                      key={index + "images"}
                      style={{ marginTop: 15 }}
                    >
                      <div
                        key={index}
                        className="Column"
                        style={{ alignItems: "center" }}
                      >
                        <a
                          href={hrefArray[index].concat(
                            index === hrefArray.length - 1 ? ".docx" : ".pdf",
                          )}
                          name={"view" + index}
                          id={"view" + index}
                          download={hrefArray[index]}
                        >
                          <div className="Kursmateriell-white-box">
                            <img
                              src={img}
                              alt=""
                              style={{ width: 170, height: "auto" }}
                            />
                          </div>
                        </a>
                        <div className="Empty-space-31" />
                        <a
                          href={hrefArray[index].concat(
                            index === hrefArray.length - 1 ? ".docx" : ".pdf",
                          )}
                          name="download1"
                          id="download1"
                          style={{ textDecoration: "none" }}
                          download={hrefArray[index]}
                        >
                          <div className="Kursmateriell-box-title">
                            {titles[index]}
                          </div>
                        </a>
                        <div className="Column" key={index + "link"}>
                          <div className="Empty-space-15" />
                          <a
                            href={hrefArray[index].concat(
                              index === hrefArray.length - 1 ? ".docx" : ".pdf",
                            )}
                            name="download2"
                            id="download2"
                            download={hrefArray[index]}
                          >
                            <div className="Kursmateriell-link-container">
                              {links[index]}
                            </div>
                          </a>
                        </div>
                        <div className="Fill-empty-space" />
                      </div>
                      <div
                        className={
                          index !== images.length - 1
                            ? "Empty-column Hide-mobile"
                            : ""
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="Kursmateriell-colored-container">
                <div className="Kursmateriell-main-title Kursmateriell-main-title--small">
                  Nedlastbar versjon
                </div>
                <div className="Kursmateriell-text">{text}</div>
                <div
                  className="Row Kursmateriell-Center-content"
                  style={{ marginTop: 45 }}
                >
                  {images2.map((img, index) => (
                    <div
                      className="Row"
                      key={index + "images2"}
                      style={{ marginTop: 15 }}
                    >
                      <div
                        key={index}
                        className="Column"
                        style={{ alignItems: "center" }}
                      >
                        <a
                          href={hrefArray2[index].concat(".pdf")}
                          name={"view" + index}
                          id={"view" + index}
                          download={hrefArray2[index]}
                        >
                          <div className="Kursmateriell-white-box">
                            <img
                              src={img}
                              alt=""
                              style={{ width: 120, height: "auto" }}
                            />
                          </div>
                        </a>
                        <div className="Empty-space-31" />
                        <a
                          href={hrefArray2[index].concat(".pdf")}
                          name="download1"
                          id="download1"
                          style={{ textDecoration: "none" }}
                          download={hrefArray2[index]}
                        >
                          <div className="Kursmateriell-box-title">
                            {titles2[index]}
                          </div>
                        </a>
                        <div className="Column" key={index + "link"}>
                          <div className="Empty-space-15" />
                          <a
                            href={hrefArray2[index].concat(".pdf")}
                            name="download2"
                            id="download2"
                            download={hrefArray2[index]}
                          >
                            <div className="Kursmateriell-link-container">
                              {links2[index]}
                            </div>
                          </a>
                        </div>
                        <div className="Fill-empty-space" />
                      </div>
                      <div
                        className={
                          index !== images2.length - 1
                            ? "Empty-column Hide-mobile"
                            : ""
                        }
                      />
                    </div>
                  ))}
                  <div className="Kursmateriell-empty" style={{ width: 530 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <BottomBar />
      </div>
    );
  }
}

export default Kursmateriell;



// WEBPACK FOOTER //
// ./src/pages/Dialogduk/index.js